

<div class="containerBody white-background br8">
  <div #chartContainer id="chartContainer">
    <canvas #canvas></canvas>
  </div>
</div>

